export default __webpack_public_path__ + "static/media/deckle-match-result-cover.d0f1469e.svg";